import type { AxiosInstance } from 'axios'
import URI from 'urijs'

import { CategoryListInterface } from '../../interfaces/category'
import { Pagination } from '../../interfaces/common'

export const getCategoryList = (api: AxiosInstance) => (
  page = 1,
  limit?: number,
  sortBy?: string,
  sortDirection?: string,
  q?: string
): Promise<Pagination<CategoryListInterface>> =>
  api.get(
    '/v1.0/admin/categories?' +
      URI.buildQuery({
        page,
        limit,
        sortBy,
        sortDirection,
        keyword: q
      })
  )
